module.exports = __webpack_public_path__ + "img/wild_comming.e5d3768e.png";